export const EMAIL_REGEX: RegExp = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$/
export const PHONE_REGEX: RegExp = /^\+[0-9]+$/
/** INSEE commune code: 2-digit department (or 2A/2B for Corsica) followed by 3 digits. */
export const INSEE_CODE_REGEX: RegExp = /^(\d{2}|2[AB])\d{3}$/
